import { useState, useEffect } from "react";
import { instancesAPI } from "../services/api";
import { useTheme } from "../contexts/ThemeContext";

const tierLabel = (tier) => {
  const map = { TIER_250: "250", TIER_1K: "1K", TIER_2K: "2K", TIER_10K: "10K", TIER_100K: "100K", UNLIMITED: "∞" };
  return map[tier] || tier || "—";
};

const qualityColor = (q) => {
  if (q === "GREEN") return "text-green-500";
  if (q === "YELLOW") return "text-yellow-500";
  if (q === "RED") return "text-red-500";
  return "text-gray-400";
};

export default function UsageBar({ instanceId }) {
  const { darkMode } = useTheme();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!instanceId) return;
    instancesAPI.getUsage(instanceId)
      .then((r) => setData(r.data))
      .catch(() => {});
  }, [instanceId]);

  if (!data || !data.messaging_limit?.tier) return null;

  const { quality_rating, messaging_limit } = data;
  const { tier, limit, used, percentage } = messaging_limit;
  const subtle = darkMode ? "text-gray-400" : "text-gray-600";
  const bold = darkMode ? "text-white" : "text-gray-900";

  return (
    <>
      <div className="flex items-center justify-between">
        <span className={`text-sm ${subtle}`}>Quality:</span>
        <span className={`text-sm font-medium ${qualityColor(quality_rating)}`}>
          {quality_rating || "—"}
        </span>
      </div>
      <div className="flex items-center justify-between">
        <span className={`text-sm ${subtle}`}>Limite (24h):</span>
        <span className={`text-sm font-medium ${bold}`}>
          {used} / {limit.toLocaleString("pt-BR")} ({percentage}%)
        </span>
      </div>
      <div className="flex items-center justify-between">
        <span className={`text-sm ${subtle}`}>Tier:</span>
        <span className={`text-sm font-medium ${bold}`}>
          {tierLabel(tier)}
        </span>
      </div>
    </>
  );
}
